export const sidebarTextColor = '#ffffff'

export const sidebarPalette = {
  text: sidebarTextColor,
  separator: '#5E6A7A',
  light: sidebarTextColor,
  main: '#293341',
  dark: '#3b4755',
}

export const sidebarContentSx = {
  color: sidebarPalette.text,
  '& .MuiTypography-root': {
    color: 'inherit',
  },
  '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
    color: 'inherit',
  },
} as const

export const sidebarActiveItemSx = {
  '&.active': {
    borderLeft: '0.5rem solid',
    borderColor: 'primary.main',
    backgroundColor: sidebarPalette.dark,
    paddingLeft: '1.1rem',
  },
}

export const sidebarFooterIconSx = {
  color: sidebarPalette.light,
  minWidth: '2.4rem',
}
